import { FileDoneOutlined } from '@ant-design/icons'

import Link from '~/core/Link'
import Box from '~/core/Box'
import Tooltip from '~/core/Tooltip'
import { BLACK_ALPHA_BOTTOM } from '~/apps/consumer/components/PartViewerModal/logic'
import { ThumbnailType } from '~/apps/consumer/components/PartViewerModal/types'

const PDFThumbnail = (props: ThumbnailType) => {
    const { file } = props

    return (
        <Tooltip title={file.fileName}>
            <Link
                name="download-fictiv5"
                placement="inspections-ui"
                href={file.downloadUrl}
                data-test-target="pdf-thumbnail"
                target="_blank"
            >
                <Box
                    border={BLACK_ALPHA_BOTTOM}
                    borderRadius="4px"
                    padding="15px 20px 5px 20px"
                    direction="col"
                    margin="0 5px 5px 0"
                >
                    <FileDoneOutlined
                        style={{
                            fontSize: 20,
                            marginBottom: 5,
                        }}
                    />
                    PDF
                </Box>
            </Link>
        </Tooltip>
    )
}

export default PDFThumbnail
